import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { H2, Currency } from '../../components';

import { OrderDetailsSummaryBlock } from '../orderDetails/';

import { FIELD_NA } from '../constants';
import { PAYMENT_METHOD_FREE } from '../orderReturns/constants';

const ReturnDetailsSidebar = ({
  account,
  department,
  orderType,
  customerPo,
  orderSubmittedBy,
  orderReferenceNumber,
  creditType,
  returnReason,
  returnComments,
  referenceId,
  returnSubmittedBy,
  returnSubmittedDate,
  returnExpirationDate,
  totalReturnAmount,
  totalQty,
  currencyCode,
  paymentMethod,
  warehouseAddress
}) => (
  <div className='returnDetails__sidebarInner ta-sm-l flex-container column start u-full-width'>
    <div className='ta-sm-l prl6-sm border-bottom u-full-width'>
      <OrderDetailsSummaryBlock headerId='global.account' value={account} />
      <OrderDetailsSummaryBlock headerId='global.department' value={department || FIELD_NA} />
      {orderType && <OrderDetailsSummaryBlock headerId='global.orderType' value={orderType} />}
      <OrderDetailsSummaryBlock headerId='orderstatus.poNumber' value={customerPo} />
      <OrderDetailsSummaryBlock headerId='orderreturns.orderSubmittedBy' value={orderSubmittedBy} />
      <OrderDetailsSummaryBlock headerId='orderreturns.orderReferenceNumber' value={orderReferenceNumber} />
    </div>
    <div className='ta-sm-l prl6-sm pt5-sm border-bottom u-full-width'>
      <OrderDetailsSummaryBlock headerId='returnStatus.creditType' value={creditType} />
      <OrderDetailsSummaryBlock headerId='orderreturns.returnReason' value={returnReason} />
      {returnComments && <OrderDetailsSummaryBlock headerId='orderreturns.returnComments' value={returnComments} />}
      <OrderDetailsSummaryBlock headerId='orderreturns.returnReferenceId' value={referenceId} />
      <OrderDetailsSummaryBlock
        headerId='orderstatus.orderSubmittedDate'
        value={
          returnSubmittedDate && (
            <FormattedDate value={returnSubmittedDate} year='numeric' month='numeric' day='numeric' />
          )
        }
      />
      <OrderDetailsSummaryBlock headerId='orderreturns.returnSubmitted.by' value={returnSubmittedBy} />
      <OrderDetailsSummaryBlock
        headerId='returnDetails.expiration'
        value={
          returnExpirationDate && (
            <FormattedDate value={returnExpirationDate} year='numeric' month='numeric' day='numeric' />
          )
        }
      />
      <OrderDetailsSummaryBlock
        headerId={new TranslatedCopy({ id: 'orderreturns.submitted.returnAddress' }).toString()}
        value={
          warehouseAddress && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>{warehouseAddress.name}</span>
              <span>{warehouseAddress.addressLine1}</span>
              <span>{warehouseAddress.addressLine2}</span>
              <span>
                {warehouseAddress.city}
                {', '}
                {warehouseAddress.state} {warehouseAddress.zipCode}
              </span>
            </div>
          )
        }
      />
      <OrderDetailsSummaryBlock headerId='orderreturns.totalQuantity.copy' value={totalQty} />
    </div>
    <div className='p6-sm flex-container row space-between border-bottom u-full-width'>
      <H2>
        <TranslatedCopy id='orderreturns.returnAmount' />*
      </H2>
      <Currency value={paymentMethod === PAYMENT_METHOD_FREE ? '0' : totalReturnAmount || '0'} type={currencyCode} />
    </div>
  </div>
);

ReturnDetailsSidebar.propTypes = {
  account: PropTypes.string.isRequired,
  department: PropTypes.string.isRequired,
  orderType: PropTypes.string.isRequired,
  customerPo: PropTypes.string.isRequired,
  orderSubmittedBy: PropTypes.string.isRequired,
  orderReferenceNumber: PropTypes.string.isRequired,
  // --
  creditType: PropTypes.string.isRequired,
  returnReason: PropTypes.string.isRequired,
  returnComments: PropTypes.string.isRequired,
  referenceId: PropTypes.string.isRequired,
  returnSubmittedBy: PropTypes.string.isRequired,
  returnSubmittedDate: PropTypes.string.isRequired,
  returnExpirationDate: PropTypes.string.isRequired,
  totalReturnAmount: PropTypes.number.isRequired,
  // --
  totalQty: PropTypes.number.isRequired,
  currencyCode: PropTypes.string,
  paymentMethod: PropTypes.string.isRequired,
  warehouseAddress: PropTypes.object.isRequired
};

ReturnDetailsSidebar.defaultProps = {
  currencyCode: null
};

export default ReturnDetailsSidebar;
